<template>
  <div class="modal-background">
    <div class="modal-container">
      <div class="modal-title">
        <div class="is-18m">{{photoDetail.photoBoard.title}}</div>
        <svg class="close-icon" @click="$emit('close')" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 5.5L5 19.5M19 19.5L5 5.5" stroke="#646464" stroke-width="2" stroke-linecap="round" />
        </svg>
      </div>
      <div class="modal-content">
        <div class="text-area is-14m">
          {{photoDetail.photoBoard.content}}
        </div>
        <div v-for="(file, index) in photoDetail.photoFiles" :key="'phtFile' + index" class="content-img">
          <img :src="file.path" alt="file" class="photo-file" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useMembershipStore} from '~/store/membership/index.js'
import {useAdminMembershipStore} from '~/store/admin-membership/index.js'

export default {
  name: 'PhotoViewModal',
  setup() {
    const store = useMembershipStore()
    const adminMembershipStore = useAdminMembershipStore()
    return {store, adminMembershipStore}
  },
  props: {
    photoId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      photoDetail: {
        photoBoard: {
          id: 0,
          title: '',
          content: ''
        },
        photoFiles: [
          {
            path: ''
          }
        ]
      }
    }
  },
  async mounted() {
    await this.getMembershipPhotoBoardDetail()
    document.body.style.overflow = 'hidden'
  },
  unmounted() {
    document.body.style.overflow = 'auto'
  },
  methods: {
    async getMembershipPhotoBoardDetail() {
      try {
        const {data} = await this.store.getMembershipPhotoBoardDetail(this.photoId)
        this.photoDetail.photoBoard = data.photoBoard
        this.photoDetail.photoFiles = data.photoFiles
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    }
  }
}
</script>

<style scoped lang="scss">
.button {
  padding: 8px 16px;
  background: #0058aa;
  text-align: center;
  border-radius: 5px;
  color: #ffffff;
  cursor: pointer;
}
.file-wrapper {
  margin-top: 24px;
  margin-bottom: 24px;
  position: relative;
  color: #dbdbdb;
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;

  .button {
    padding: 4px 8px;
    background: #0f0f0f;
    border-radius: 5px;
    color: #ffffff;
  }

  .file-input {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }
}
.modal-background {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #0f0f0f50;
  z-index: 100;
}
.modal-container {
  width: 640px;
  min-height: 320px;
  max-height: calc(100% - 64px);
  padding: 30px;
  background: #ffffff;
  overflow: auto;
  .modal-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    .is-18m {
      width: 100%;
    }
  }
  .text-area {
    white-space: pre-line;
    padding: 16px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 16px;
  }
  .modal-content {
    overflow: auto;
    .is-14r {
      margin-bottom: 16px;
      white-space: pre-line;
    }
    .content-img {
      margin-bottom: 16px;
      position: relative;
      .close-icon {
        position: absolute;
        right: 15px;
        top: 15px;
        cursor: pointer;
      }
    }
  }
}
</style>
